import { getDocs, query, where } from "firebase/firestore";
import { useEffect, useContext, useState } from "react";
import { AuthContext } from "../providers/AuthProvider";

/* This method of fetching the timesheets is only used in Exports. It is used to fetch
  primaries (timesheets and quotes) once. This is in contrast to TimesheetsProvider 
  which listens for changes on the db and updates local state accordingly.
*/

export const useTimesheets = (dbRef) => {
  // const { timesheets, setTimesheets } = useContext(TimesheetsContext);
  const [timesheets, setTimesheets] = useState([]);

  const { userData } = useContext(AuthContext);

  useEffect(() => {
    // Guard against the cold-load race where this mounts before AuthContext's userData has
    // streamed in - associatedAccounts is still [] then, and Firestore throws synchronously
    // on an empty 'in' filter (see useJobDescriptions.js for the same fix).
    if (!userData.uid) {
      return;
    }

    let q = query(dbRef, where("createdBy", "in", userData.associatedAccounts));
    getDocs(q).then(function (doc) {
      let timesheetData = [];

      doc.forEach((ts) => {
        timesheetData.push(ts.data());
      });

      setTimesheets(timesheetData);
    });
  }, [dbRef, userData.associatedAccounts, userData.uid]);

  return timesheets;
};
